import { cn } from '@/lib/utils';
import AppLogoIcon from './app-logo-icon';

export default function AppLogo({ light = false }: { light?: boolean }) {
    const color = light ? 'text-white' : 'text-[#003567] dark:text-primary';

    return (
        <>
            <div className="flex aspect-square size-12 items-center justify-center">
                <AppLogoIcon className={cn('size-12 fill-current', color)} />
            </div>
            <div
                className={cn(
                    'ml-0 grid flex-1 text-left text-3xl',
                    light && 'ml-2',
                    color,
                )}
            >
                <span className="mb-0.5 leading-tight font-black">
                    STAYDEED
                </span>
                <span
                    className={cn(
                        'mb-0.5 ml-0.5 truncate text-[0.54rem] leading-tight font-bold',
                        light ? 'opacity-80' : 'opacity-60',
                    )}
                >
                    YOUR DEED TO A PERFECT STAY.
                </span>
                {/* <img className='px-5' src='/logo_text.jpg' /> */}
            </div>
        </>
    );
}
